import { useSelector } from 'react-redux';
import {
  Account,
  OrganizationFeature,
} from '../../../../models';
import AdditionalSubscriptionRow from './AdditionalSubscriptionRow';
import {
  fromStudioSubscriptions,
  useAppDispatch,
} from '../../../../store';

export interface KseSubscriptionDetailsRowProps {
  account: Account | null,
  organizationId: number,
}

const KseSubscriptionDetails = (props: KseSubscriptionDetailsRowProps) => {
  const {
    account,
    organizationId,
  } = props;

  const dispatch = useAppDispatch();
  const currentKSESubscription = useSelector(
    fromStudioSubscriptions.selectByAccountIdAndFeature(
      Number(account?.id),
      OrganizationFeature.PER_USER_KSE,
    ),
  )?.[0];

  const handleRefreshSubscription = async () => {
    await Promise.all([
      dispatch(fromStudioSubscriptions.doGetActiveByAccountId({
        accountId: Number(account?.id),
      })),
    ]);
  };

  return (
    currentKSESubscription ? (
      <>
        <AdditionalSubscriptionRow
          key="subscriptions.katalon_studio_enterprise"
          name="subscriptions.katalon_studio_enterprise"
          organizationId={organizationId}
          currentSubscription={currentKSESubscription}
          feature={OrganizationFeature.PER_USER_KSE}
          handleRefreshSubscription={handleRefreshSubscription}
          account={account}
        />
      </>
    ) : null
  );
};

export default KseSubscriptionDetails;
